import { render, staticRenderFns } from "./TabsTab.vue?vue&type=template&id=0d0be316&"
import script from "./TabsTab.vue?vue&type=script&lang=js&"
export * from "./TabsTab.vue?vue&type=script&lang=js&"
import style0 from "./TabsTab.vue?vue&type=style&index=0&id=0d0be316&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports